import { formatCurrency } from "@/utils/format-currency";
import { formatLabel } from "@/utils/format-label";
import { Box } from "@mui/material";
import { format, parseISO, isValid } from "date-fns";
import { TransactionActionsPopover } from "./transaction-actions-popover";

export const TransactionColumns = [
  {
    accessorKey: "refNo",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Ref. No</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>{row.original.refNo ?? "N/A"}</div>
    ),
  },
  {
    accessorKey: "customerName",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Customer Name</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
        {row.original.customerName ?? "N/A"}
      </div>
    ),
  },
  {
    accessorKey: "amount",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Amount</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>
        {formatCurrency(row.original.amount) ?? "0"}
      </div>
    ),
  },
  {
    accessorKey: "status",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Status</div>,
    cell: ({ row }) => {
      const status = row.original.status;

      const getStatusColor = () => {
        switch (status) {
          case "SUCCESSFUL":
            return { bg: "#ecfdf5", color: "#065f46" };
          case "FAILED":
            return { bg: "#fef2f2", color: "#991b1b" };
          case "PENDING":
          default:
            return { bg: "#fffbeb", color: "#92400e" };
        }
      };

      const { bg, color } = getStatusColor();

      return (
        <Box
          sx={{
            display: "inline-flex",
            alignItems: "center",
            px: 2,
            py: 0.5,
            borderRadius: "999px",
            backgroundColor: bg,
            color: color,
            fontSize: "0.8rem",
            fontWeight: 500,
          }}
        >
          {formatLabel(status) ?? "N/A"}
        </Box>
      );
    },
  },
  {
    accessorKey: "channel",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Channel</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem" }}>{row.original.channel ?? "N/A"}</div>
    ),
  },
  {
    accessorKey: "tranDate",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Date</div>,
    cell: ({ row }) => {
      const date = row.original.tranDate;

      if (!date) return <div style={{ fontSize: "0.85rem" }}>N/A</div>;

      const parsed = parseISO(date);

      return (
        <div style={{ fontSize: "0.85rem", whiteSpace: "nowrap" }}>
          {isValid(parsed) ? format(parsed, "MMM d, yyyy") : "N/A"}
        </div>
      );
    },
  },
  {
    id: "actions",
    header: () => <div style={{ whiteSpace: "nowrap" }}>Actions</div>,
    cell: ({ row }) => (
      <div style={{ fontSize: "0.85rem", cursor: "pointer" }}>
        <TransactionActionsPopover transaction={row.original} />
      </div>
    ),
  },
];
